import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { LockIcon, MailIcon, SendIcon } from 'lucide-react';
import { EncabezadoPagina } from '../components/layout/AppLayout';
import { EncabezadoPanel, Panel } from '../components/ui/Basicos';
import { Avatar } from '../components/ui/Etiquetas';
import { ChipEstadoGoogle, IconoGoogle } from '../components/ui/Google';
import { useDatos } from '../contexts/DatosContext';
import { inicialesDe } from '../data/abogados';
import { etiquetaAnticipacion, fechaHora } from '../utils/google';
export function ConfigIntegraciones() {
  const {
    rol,
    abogados,
    sucursales,
    conexionGoogleDe,
    conexionesGoogle,
    eventosGoogle,
    reenviarInvitacionGoogle
  } = useDatos();
  const [aviso, setAviso] = useState('');
  if (rol !== 'Administrador') {
    return <Panel data-id="element-1180" data-mp="rutjath2lvq6">
        <div className="flex flex-col items-center gap-3 px-6 py-14 text-center" data-id="element-1181" data-mp="rvcrhigx55r0">
          <LockIcon className="h-6 w-6 text-gris-300" aria-hidden="true" data-id="element-1182" data-mp="wtec47tztd4l" />
          <p className="text-sm font-semibold text-gris-700" data-id="element-1183" data-mp="15vvcu0gr3ad1">Módulo restringido</p>
          <p className="max-w-sm text-xs text-gris-500" data-id="element-1184" data-mp="11555wisoezg8">
            Solo el rol Administrador puede revisar el estado de las integraciones del despacho.
          </p>
        </div>
      </Panel>;
  }
  const personal = abogados.filter(a => a.rol !== 'Recepción/Archivo');
  const conectados = personal.filter(a => conexionGoogleDe(a.id).estado === 'conectado').length;
  const conError = conexionesGoogle.filter(c => c.estado === 'error').length;
  return <>
      <EncabezadoPagina titulo="Integraciones" descripcion="Estado de la conexión con Google Calendar de cada abogado. La autorización siempre la hace la persona desde su cuenta." data-id="element-1185" data-mp="1jtjxp8atihi3" />

      <div className="mb-4 grid grid-cols-2 gap-4 lg:grid-cols-4" data-id="element-1186" data-mp="1ax14duyocrkz">
        {[{
        etiqueta: 'Cuentas conectadas',
        valor: `${conectados} de ${personal.length}`
      }, {
        etiqueta: 'Sin conectar',
        valor: String(personal.length - conectados - conError)
      }, {
        etiqueta: 'Con error',
        valor: String(conError),
        alerta: conError > 0
      }, {
        etiqueta: 'Eventos espejo en Google',
        valor: String(eventosGoogle.length)
      }].map(m => <Panel key={m.etiqueta} className="px-5 py-4" data-id="element-1187" data-mp="3n69dijv5jo4g">
            <p className="text-2xs uppercase tracking-wide text-gris-400" data-id="element-1188" data-mp="3s1opf69ln9y8">{m.etiqueta}</p>
            <p className={`tabular mt-1 text-2xl font-semibold ${m.alerta ? 'text-peligro-600' : 'text-marino-900'}`} data-id="element-1189" data-mp="3eajxyrgdxnyz">
              {m.valor}
            </p>
          </Panel>)}
      </div>

      {aviso && <p role="status" className="mb-4 rounded border border-exito-100 bg-exito-50 px-4 py-2 text-xs font-medium text-exito-700" data-id="element-1190" data-mp="39byzoxkp1ed6">
          {aviso}
        </p>}

      <Panel data-id="element-1191" data-mp="2zeu7oh462oog">
        <EncabezadoPanel titulo="Google Calendar por abogado" descripcion="Cada quien vincula su propia cuenta; desde aquí puedes reenviar la invitación a conectar." accion={<IconoGoogle className="h-5 w-5" data-id="element-1193" data-mp="2brpcvt3bsaoa" />} data-id="element-1192" data-mp="2zd9eautl9bs6" />

        <div className="overflow-x-auto scroll-fino" data-id="element-1194" data-mp="2bta7fipn3tm5">
          <table className="w-full min-w-[1080px] text-sm" data-id="element-1195" data-mp="2prhxr7s67woc">
            <thead data-id="element-1196" data-mp="2krvlb0k62kgl">
              <tr className="bg-gris-50 text-left text-2xs uppercase tracking-wide text-gris-500" data-id="element-1197" data-mp="2krccc9chv6ep">
                <th scope="col" className="px-5 py-2.5 font-semibold" data-id="element-1198" data-mp="2zo32ds0a35rn">
                  Abogado
                </th>
                <th scope="col" className="px-3 py-2.5 font-semibold" data-id="element-1199" data-mp="2up0azad80y25">
                  Estado
                </th>
                <th scope="col" className="px-3 py-2.5 font-semibold" data-id="element-1200" data-mp="38ges1bnkip6k">
                  Cuenta de Google
                </th>
                <th scope="col" className="px-3 py-2.5 font-semibold" data-id="element-1201" data-mp="3ifdrq4qcvahf">
                  Qué sincroniza
                </th>
                <th scope="col" className="px-3 py-2.5 font-semibold" data-id="element-1202" data-mp="3dgt0gut30154">
                  Recordatorio
                </th>
                <th scope="col" className="px-3 py-2.5 text-right font-semibold" data-id="element-1203" data-mp="1c88lis29dap">
                  Eventos
                </th>
                <th scope="col" className="px-5 py-2.5 text-right font-semibold" data-id="element-1204" data-mp="5cides449xnz">
                  Acciones
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gris-100" data-id="element-1205" data-mp="f3d3k7khhhep">
              {personal.map(a => {
              const c = conexionGoogleDe(a.id);
              const eventos = eventosGoogle.filter(e => e.abogadoId === a.id).length;
              const sucursal = sucursales.find(s => s.id === a.sucursalId);
              const tipos = [c.sincronizarAudiencias && 'Audiencias', c.sincronizarCitas && 'Citas', c.sincronizarVencimientos && 'Vencimientos'].filter(Boolean) as string[];
              return <tr key={a.id} className="align-top" data-id="element-1206" data-mp="17safzu20kjzj">
                    <td className="px-5 py-3" data-id="element-1207" data-mp="17uwqo2k7bflz">
                      <div className="flex items-center gap-3" data-id="element-1208" data-mp="2sa2wo8a96zkv">
                        <Avatar iniciales={inicialesDe(a.nombre)} foto={a.foto} tamano="md" nombre={a.nombre} tono={a.activo ? 'marino' : 'gris'} data-id="element-1209" data-mp="2ncb5xhlchji9" />
                        <div className="min-w-0" data-id="element-1210" data-mp="29kd4lsxvkrwn">
                          <Link to={`/abogados/${a.id}`} className="block truncate text-sm font-semibold text-marino-800 hover:underline" data-id="element-1211" data-mp="29m7nz2ti0bym">
                            {a.nombre}
                          </Link>
                          <p className="mt-0.5 text-2xs text-gris-400" data-id="element-1212" data-mp="1uox352uyttq8">
                            {a.rol} · {sucursal?.nombre ?? '—'}
                          </p>
                        </div>
                      </div>
                    </td>
                    <td className="px-3 py-3" data-id="element-1213" data-mp="1nc7ktvzub43t">
                      <ChipEstadoGoogle estado={c.estado} data-id="element-1214" data-mp="1nbftwyh6tujv" />
                      {c.estado === 'error' && c.mensajeError && <p className="mt-1 max-w-[14rem] text-2xs text-peligro-600" data-id="element-1215" data-mp="1s50p6irecafd">
                          {c.mensajeError}
                        </p>}
                    </td>
                    <td className="px-3 py-3 text-xs text-gris-700" data-id="element-1216" data-mp="1ias0y79ef3n0">
                      {c.correoGoogle ?? '—'}
                      <span className="tabular mt-0.5 block text-2xs text-gris-400" data-id="element-1217" data-mp="2b1saexqi0zm2">
                        {c.estado === 'conectado' ? `Última sync: ${fechaHora(c.ultimaSync)}` : c.invitacionEnviada ? `Invitación: ${fechaHora(c.invitacionEnviada)}` : 'Sin invitación enviada'}
                      </span>
                    </td>
                    <td className="px-3 py-3 text-xs text-gris-700" data-id="element-1218" data-mp="pp8mzhxevq4c">
                      {c.estado === 'conectado' ? tipos.length > 0 ? tipos.join(' · ') : 'Nada seleccionado' : '—'}
                      {c.estado === 'conectado' && <span className="mt-0.5 block text-2xs text-gris-400" data-id="element-1219" data-mp="s0rnnrzoc6qy">
                          Calendario:{' '}
                          {c.calendarios.find(cal => cal.id === c.calendarioDestino)?.nombre}
                        </span>}
                    </td>
                    <td className="px-3 py-3 text-xs text-gris-700" data-id="element-1220" data-mp="3qin7qw1zsf4b">
                      {c.estado === 'conectado' ? etiquetaAnticipacion(c.anticipacionMinutos) : '—'}
                    </td>
                    <td className="tabular px-3 py-3 text-right text-xs text-gris-700" data-id="element-1221" data-mp="4bgjs1n11w8l">{eventos}</td>
                    <td className="px-5 py-3 text-right" data-id="element-1222" data-mp="3cr8joat89nqe">
                      {c.estado === 'conectado' ? <Link to={`/abogados/${a.id}`} className="inline-flex h-8 items-center gap-1.5 rounded border border-gris-200 px-2.5 text-2xs font-semibold text-marino-700 transition-colors duration-150 hover:border-marino-300 hover:bg-marino-50" data-id="element-1223" data-mp="2max5mqfvh9kj">
                          <MailIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-1224" data-mp="30ayfuwi11tco" />
                          Ver preferencias
                        </Link> : <button type="button" onClick={() => {
                    reenviarInvitacionGoogle(a.id);
                    setAviso(`Invitación para conectar Google Calendar reenviada a ${a.correo}.`);
                  }} className="inline-flex h-8 items-center gap-1.5 rounded border border-gris-200 px-2.5 text-2xs font-semibold text-marino-700 transition-colors duration-150 hover:border-marino-300 hover:bg-marino-50" data-id="element-1225" data-mp="3a8maznjjp2vd">
                          <SendIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-1226" data-mp="1cbw28jnjbwvj" />
                          Reenviar invitación
                        </button>}
                    </td>
                  </tr>;
            })}
            </tbody>
          </table>
        </div>
      </Panel>
    </>;
}